import axios from 'axios'
import * as types from '../mutation-types'

const initialState = {
  current_enrollment_id: null,
  current_enrollment: {},
  current_enrollment_student: {},
  current_enrollment_sons: [],
  current_enrollment_data_digital_sign: [],
  extemp: false,
  extempGen: false,
  extempDetail: [],
  externalPayment: false,
  externalPaymentDetail: [],
  year: 0,
  receipt: null,
  positive_balance: false,
  positive_balance_value: [],
  fee: false,
  fee_value: [],
  family_portfolio: [],
  yearly_payment: false,
}

export const state = { ...initialState }

export const actions = {
  setEnrollmentId ({ commit }, payload) {
    commit(types.SET_ENROLLMENT_ID, payload)
  },
  createEnrollment ({ commit, dispatch }, payload) {
    axios.post('/api/enrollment/create', payload)
      .then(resp => {
        if (resp.status === 200) {
          commit(types.SET_ENROLLMENT, resp.data.enrollment)
          commit(types.SET_ENROLLMENT_STUDENT, resp.data.student)
          const payload = {
            enrollment_id: resp.data.enrollment.enrollment_id,
            student_id: resp.data.student.id
          }
          dispatch('fetchEnrollmentStatus', payload);
        }
      })
      .catch(error => console.log(error))
  },
  fetchEnrollmentStatus ({ commit }, payload) {
    axios.get(`/api/enrollment/status/${payload.enrollment_id}/${payload.student_id}`)
      .then(resp => {
        if (resp.status === 200) {
          commit(types.SET_ENROLLMENT, resp.data.enrollment)
          commit(types.SET_ENROLLMENT_STUDENT, resp.data.student)
        }
      })
      .catch(error => console.log(error))
  },
  fetchSons ({ commit }, { enrollment_id }) {
    return axios.get(`/api/enrollment/start/getSons/${enrollment_id}`)
      .then(resp => {
        if (resp.status === 200) {
          commit(types.FETCH_SONS, resp.data)
        }
      })
      .catch(error => console.log(error))
  },
  fetchEnrollmentDataDigitalSign ({ commit }) {
    return axios.get('/api/enrollment/start/enrollmentDataDigitalSign')
      .then(resp => {
        if (resp.status === 200) {
          commit(types.FETCH_ENROLLMENT_DATA_DIGITAL_SIGN, resp.data)
        }
      })
      .catch(error => console.log(error))
  },
  fetchSiesaReceipts({ commit, state }, payload) {
    const newPayload = {...payload, year: state.year}
    axios.post('/api/enrollment/family/siesaReceipts', newPayload)
      .then(resp => {
        if (resp.status === 200) {
          commit(types.SET_SIESA_RECEIPT, resp.data.receipt)
        }
      })
      .catch(err => console.log(err))
  }
}

export const mutations = {
  [types.SET_ENROLLMENT_ID] (state, { enrollment_id }) {
    state.current_enrollment_id = enrollment_id
  },
  [types.SET_ENROLLMENT] (state, enrollment) {
    state.current_enrollment = enrollment
  },
  [types.SET_ENROLLMENT_STUDENT] (state, student) {
    state.current_enrollment_student = student
  },
  [types.CLEAR_ENROLLMENT_PROCESS] (state) {
    state = { ...initialState }
  },
  [types.FETCH_SONS] (state, sons) {
    state.current_enrollment_sons = sons
  },
  [types.FETCH_ENROLLMENT_DATA_DIGITAL_SIGN] (state, enrollment_data_digital_sign) {
    state.current_enrollment_data_digital_sign = enrollment_data_digital_sign
  },
  [types.SET_EXTEMP] (state, payload) {
    state.extemp = payload.extempConfig
    state.extempGen = payload.extempGen
  },
  [types.SET_EXTEMP_DETAIL] (state, extempDetail) {
    state.extempDetail = extempDetail
  },
  [types.SET_EXTERNAL_PAYMENT] (state, externalPayment) {
    state.externalPayment = externalPayment
  },
  [types.SET_EXTERNAL_PAYMENT_DETAIL] (state, externalPaymentDetail) {
    state.externalPaymentDetail = externalPaymentDetail
  },
  [types.SET_ENROLLMENT_YEAR] (state, year) {
    state.year = year
  },
  [types.SET_SIESA_RECEIPT] (state, receipt) {
    state.receipt = receipt
  },
  [types.POSITIVE_BALANCE] (state, payload) {
    state.positive_balance = payload.active
    state.positive_balance_value = payload.value
  },
  [types.SET_PORTFOLIO] (state, portfolio) {
    state.family_portfolio = portfolio
  },
  [types.FEE] (state, payload) {
    state.fee = payload.active
    state.fee_value = payload.value
  },
  [types.SET_YEARLY_PAYMENT] (state, active) {
    state.yearly_payment = active
  },
  [types.SET_STUDENTS_ACCESS] (state, access) {
    state.students_access = access
  }
}

export const getters = {
  currentEnrollmentId: state => state.current_enrollment_id,
  currentEnrollment: state => state.current_enrollment,
  currentEnrollmentStudent: state => state.current_enrollment_student,
  currentEnrollmentStudentId: state => state.current_enrollment_student.id,
  currentEnrollmentStatusId: state => state.current_enrollment.id,
  currentEnrollmentSons: state => state.current_enrollment_sons,
  currentEnrollmentDataDigitalSign: state => state.current_enrollment_data_digital_sign,
  isExtempEnrollment: state => state.extempConfig,
  isExtempGenEnrollment: state => state.extempGen,
  extempDetail: state => state.extempDetail,
  hasExternalPayment: state => state.externalPayment,
  externalPaymentDetail: state => state.externalPaymentDetail,
  enrollmentYear: state => state.year,
  receipt: state => state.receipt,
  hasPositiveBalance: state => state.positive_balance,
  positiveBalance: state => state.positive_balance_value,
  hasFee: state => state.fee,
  fee: state => state.fee_value,
  familyPortfolio: state => state.family_portfolio,
  yearly_payment: state => state.yearly_payment,
  studentsAccess: state => state.students_access,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/enrollment.js